import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    studentRegisterViewContainer: {
        width: '100%'
    },
    resumeParserContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: 'url("https://res.cloudinary.com/studentbe/image/upload/v1737040194/student-be-assets/shines.png") !important',
        backgroundSize: '40%',
        backgroundPosition: '80% 41%',
        backgroundRepeat: 'no-repeat'
    },
    manualContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundSize: '65%',
        backgroundPosition: '100% 21%',
        backgroundRepeat: 'no-repeat'
    },
    progressCircleContainer: {
        width: '100%',
        height: '595px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    form: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    formTitle: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '47px',
        fontFamily: 'GreedWide-Bold',
        color: theme.palette.fg['black'],
        fontSize: '29px',
        lineHeight: '49px',
        textAlign: 'center',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
            paddingBottom: '87px'
        }
    },
    formTitleResumeParser: {
        fontFamily: 'GreedWide-Bold',
        color: theme.palette.fg['black'],
        fontSize: '26px',
        lineHeight: '49px',
        textAlign: 'center',
        margin: 'auto'
    },
    completingProfile: {
        fontFamily: 'GreedWide-Medium',
        color: theme.palette.fg['black'],
        fontSize: '20px',
        marginBottom: '35px'
    },
    formSubtitle: {
        fontFamily: 'GreedStandard-Regular',
        fontSize: '17px',
        width: '70%',
        textAlign: 'center'
    },
    barField: {
        width: '70%',
        marginTop: '80px',
        marginBottom: '80px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
    },
    automaticComplete: {
        width: 'auto !important',
        backgroundColor: `${theme.palette.bg.purple} !important`,
        border: 'none !important',
        fontSize: '11px !important',
        minHeight: '0px !important',
        textTransform: 'none',
        padding: '8px 20px !important'
    },
    manualComplete: {
        width: 'auto !important',
        textTransform: 'none',
        color: `4px 4px 0px 0px ${theme.palette.bg.black} !important`,
        marginBottom: '60px !important',
        marginTop: '25px !important',
        backgroundColor: `${theme.palette.bg.white} !important`,
        border: `1px solid  ${theme.palette.bg.black} !important`,
        fontSize: '11px !important',
        minHeight: '0px !important',
        padding: '8px 30px !important',
        '&:hover': {
            boxShadow: `4px 4px 0px 0px ${theme.palette.bg.black} !important`
        }
    },
    aiIcon: {
        marginLeft: '5px'
    },
    checkIcon: {
        color: `${theme.palette.bg.white}`,
        marginTop: '15px',
        fontSize: '35px !important'
    },
    infoIcon: {
        color: `${theme.palette.bg.purple}`,
        borderRadius: '40px'
    },
    uploadField: {
        textAlign: 'center',
        position: 'relative',
        marginTop: '80px',
        marginBottom: '30px',
        left: '15px',
        width: '100% !important'
    },
    profileCompleted: {
        height: '160px',
        width: '90%',
        paddingTop: '30px',
        borderRadius: '15px',
        backgroundColor: `${theme.palette.bg.purple}`,
        textAlign: 'center',
        marginBottom: '100px',
        marginTop: '90px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
    },
    whiteText: {
        color: `${theme.palette.bg.white}`,
        fontSize: '24px',
        fontFamily: 'GreedWide-Regular'
    },
    uploadButton: {
        backgroundColor: `${theme.palette.bg.purple} !important`,
        borderRadius: '30px !important',
        border: 'none !important',
        fontSize: '10px !important',
        width: '70% !important',
        maxHeight: '3px !important'
    },
    errorTitle: {
        fontWeight: 'bold',
        fontSize: '45px',
        marginTop: '114px',
        marginBottom: '30px',
        width: '470px',
        textAlign: 'center'
    },
    errorDescription: {
        fontSize: '20px',
        marginBottom: '180px',
        width: '470px',
        textAlign: 'center'
    },
    uploadHelp: {
        backgroundColor: 'white !important',
        border: '2px solid black',
        padding: '20px 10px',
        borderRadius: '10px'
    },
    uploadIcon: {
        color: `${theme.palette.bg.white}`,
        marginLeft: '10px',
        position: 'relative',
        bottom: '1px'
    },
    submitButton: {
        width: '100% !important',
        maxWidth: '345px',
        textTransform: 'capitalize !important'
    }
}))
